import { useEffect, useState } from "react";
import { GrapeshotDataObject, GrapeshotResponse } from "@app/types/Cue";
import axios from "axios";

const fetchGrapeshotData = async (
  urlPath: string
): Promise<GrapeshotDataObject[]> => {
  const response = await axios.post<GrapeshotResponse>(
    "/_plat/api/v1/grapeshot",
    { urlPath: urlPath }
  );

  return response.data?.channels || [];
};

export const useGrapeshotData = (urlPath: string) => {
  const [gsChannels, setGsChannels] = useState<GrapeshotDataObject[]>([]);

  useEffect(() => {
    const callFetch = async () => {
      setGsChannels(await fetchGrapeshotData(urlPath));
    };

    callFetch();
  }, [urlPath]);

  return { gsChannels };
};
